module.exports = __webpack_public_path__ + "img/brand-positioning.1615d06f.png";